import { getErrorJson } from '@mm/utils';
import { Dispatch } from 'redux';
import { StoreState } from '../store-interfaces';
import commonHandler from './common-handler';

export const update = (dispatch: Dispatch<StoreState>) => (error: Response) => {
  if (error.status === 422) {
    return getErrorJson(error);
  }
  commonHandler(dispatch)(error);
  throw error;
};
